import managementApi from '@utils/managementApi';

export type VisibilityType = 'public' | 'admin' | 'visitor' | 'hidden';
export type ActionButtonType = 'url' | 'video' | 'create';
export type TargetType = '_blank' | '_self';
export interface IMainCarouselItem {
  id: string;
  title: string;
  description?: string;
  backgroundImageUrl: string;
  mobileBackgroundImageUrl?: string;
  backgroundVideoUrl?: string | null;
  mobileBackgroundVideoUrl?: string | null;
  visibility?: VisibilityType;
  banner?: {
    button?: {
      label?: string;
      url?: string;
    };
  };
  actionButton?: {
    label: string;
    action: ActionButtonType;
    url: string;
    target: TargetType;
  };
  companion?: {
    id: string;
    slug?: string;
    firstName: string;
    lastName: string;
    jobTitle: string;
    imageUrl: string;
    videoUrl?: string | null;
    hideJobTitle?: boolean;
  };
}

export interface ICarouselResponse {
  data: {
    items: IMainCarouselItem[];
  };
}

export const getCarouselData = async () => {
  try {
    const response = await managementApi.get<ICarouselResponse>(
      `/v2/carousels`,
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching carousel data:', error);
    return null;
  }
};
